import '@scss/app.scss';

import { createApp } from 'vue';
import App from '@src/App.vue';
import router from '@js/router';
import { createPinia } from 'pinia';
import primeVue from '@js/primeVue';
import axios from '@js/axios';
import moment from 'moment';
import 'moment/dist/locale/sk';
import { i18n } from '@js/i18n.js';
import { useDeviceStore } from '@stores';
import { FloatLabel, IconField, InputIcon, Select, Drawer } from 'primevue';

moment.locale('sk');

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(primeVue);
app.use(axios);
app.use(i18n);

app.component('FloatLabel', FloatLabel);
app.component('InputIcon', InputIcon);
app.component('Select', Select);
app.component('Drawer', Drawer);
app.component('IconField', IconField);

useDeviceStore().initialize();

app.mount('#app');
